export default {
    namespaced: true,
    state: {
        carbon: null,
        formEvent: ""
    },
    mutations: {
        setCarbon(state, payload) { state.carbon = payload; },
        setFormEvent(state, payload) { state.formEvent = payload; },
        reset(state) {
            state.carbon = null;
            state.formEvent = "";
        }
    },
    getters: {
        carbon(state) { return state.carbon; },
        formEvent(state) { return state.formEvent; }
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/directformdata.js